import script from "./LoginAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&setup=true&lang=js"

import "./LoginAdmin.vue?vue&type=style&index=0&id=dce69ec4&lang=css"

const __exports__ = script;

export default __exports__